export const FakeService = [
    {
        "id": "001",
        "title": "Pediatrics ",
        "description": "the branch of medicine that involves the medical care of infants, children, adolescents, and young adults.",
        "link": "Read More",
        "img": ""
    },
    {
        "id": "002",
        "title": "Orthopedics",
        "description": "Orthopedics, or orthopedic services, aim at the treatment of the musculoskeletal system. This includes your bones, joints, ligaments, tendons, and muscles.",
        "link": "Read More",
        "img": ""
    },
    {
        "id": "003",
        "title": "Gynaecologist",
        "description": "Gynogest N 200mg Tablet is a progesterone (female hormone). It works on the lining of the uterus and helps to establish and maintain pregnancy in infertile women. ",
        "link": "Read More",
        "img": ""
    },
    {
        "id": "004",
        "title": "Neurology",
        "description": "Neurology is the branch of medicine that deals with the study and treatment of nervous system disorders.",
        "link": "Read More",
        "img": ""
    },
    {
        "id": "005",
        "title": "Laparoscopic surgery",
        "description": "Laparoscopy is a type of surgical procedure that allows a surgeon to access the inside of the abdomen (tummy) and pelvis without having to make large incisions in the skin.",
        "link": "Read More",
        "img": ""
    },
    {
        "id": "006",
        "title": "General Surgery",
        "description": "General surgery is a surgical specialty that focuses on alimentary canal and abdominal contents including the esophagus, stomach, small intestine, large intestine, liver, pancreas",
        "link": "Read More",
        "img": ""
    }
]